import React, { useState } from 'react';
import { startBooking } from '../services/courseService';

import { toast } from 'react-toastify';

export default function BookingForm({ courseId, onBookingSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleBooking = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await startBooking({ studentId: 'stu-123', courseId, bookingDate: new Date().toISOString() });
      onBookingSuccess();
      toast.success('Booking successful!');
    } catch (err) {
      console.error('Booking failed:', err);
      setError('Failed to book course.');
      toast.error('Failed to book course.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleBooking} className="bg-white p-6 shadow-lg rounded-lg w-full max-w-md mx-auto my-8">
      {error && <div className="text-red-600 mb-4">{error}</div>}
      <button
        type="submit"
        className={`w-full py-2 px-4 rounded text-white ${loading ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'}`}
        disabled={loading}
      >
        {loading ? 'Booking...' : 'Book Course'}
      </button>
    </form>
  );
}